import React, { useContext, useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Rating } from 'react-simple-star-rating'
import { useDispatch, useSelector } from 'react-redux'
import { addReviews } from '../../redux/slices/reviewSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import { SpinnerContext } from '../../context/spinnerContext'
import { FREEZE_CLIENT_MSG } from '../../util/constant'

const ReviewForm = ({ scheduledProperties, setIsRefresh }) => {
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => auth)
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, control } = useForm({
    defaultValues: {
      star: 0,
      description: ''
    }
  })

  // Memoize the payload to avoid unnecessary re-computations
  const payload = useMemo(
    () => ({
      cleaning_id: scheduledProperties?.cleaning_id,
      schedule_cleaner_id: scheduledProperties?.property_schedule?.schedule_cleaners?.schedule_cleaner_id,
      property_schedule_id: scheduledProperties?.property_schedule?.property_schedule_id,
      cleaners_id: scheduledProperties?.property_schedule?.schedule_cleaners?.cleaners?.cleaners_id
    }),
    [scheduledProperties]
  )

  const onSubmit = async (data) => {
    if (user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    if (data.star === 0) {
      errorToast('Please select a rating to submit your review')
      return
    }
    const reviewPayload = {
      ...payload,
      star: data.star.toString(),
      description: data.description
    }

    changeLoader(true)
    setIsRefresh(false)
    try {
      const { payload: response } = await dispatch(addReviews(reviewPayload))

      if (response?.status === 200) {
        successToast(response?.data?.status_message || 'Success!')
        setIsRefresh(true)
      } else {
        errorToast(response?.data?.status_message || 'Something went wrong')
      }
    } catch (error) {
      errorToast('Something went wrong')
      console.error('Error:', error)
    } finally {
      changeLoader(false)
    }
  }

  return (
    <div className="review_sec_main_div">
      <h4 className="house_img_gal_title">Reviews</h4>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="review_part_div">
          <div className="d-flex align-items-center gap-3 mb-3">
            <div className="d-flex gap-1">
              {/* Controller for Rating */}
              <Controller
                name="star"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Rating onClick={onChange} ratingValue={value} size={30} fillColor="#1C3A77" emptyColor="gray" allowFraction transition />
                )}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Review</label>
            <Controller
              name="description"
              control={control}
              render={({ field }) => <textarea className="form-control" placeholder="Write a Review" autoComplete="off" rows="3" {...field} />}
            />
          </div>

          <div className="text-center mt-4">
            <button className="btn btn-lg btn-block w-50 btn-primary" type="submit">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ReviewForm
